import { PaymentAction } from '../use-payment-flow';

const validActions: readonly PaymentAction[] = [
  'INTERNAL_PAYMENT',
  'EXTERNAL_PAYMENT',
  'VIEW_ALL_BENEFICIARIES',
  'CREATE_BENEFICIARY',
  'BILL_PAY',
];

export const isPaymentAction = (value: string | null): value is PaymentAction => {
  if (value === null) {
    return false;
  }

  return validActions.includes(value as PaymentAction);
};
